import { render, staticRenderFns } from "./NewsIndex.vue?vue&type=template&id=3347ed41"
import script from "./NewsIndex.vue?vue&type=script&lang=js"
export * from "./NewsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports